/**
 * Telegram sellers API Service (KAN-670): справочник продавцов Telegram-аккаунтов.
 *
 *   GET    /api/v1/telegram-sellers/        - продавцы организации с счётчиками аккаунтов
 *   POST   /api/v1/telegram-sellers/        - {name, url?, rating?, notes?}
 *   PATCH  /api/v1/telegram-sellers/{id}/   - {name?, url?, rating?, notes?}
 *   DELETE /api/v1/telegram-sellers/{id}/   - 409, если продавец привязан к аккаунтам
 */
import apiClient from './client';
import type { TelegramSeller, TelegramSellerBody } from '@/types/telegramSeller';

const BASE = '/api/v1/telegram-sellers/';

export const telegramSellersApi = {
  list: async (): Promise<TelegramSeller[]> => (await apiClient.get(BASE)).data,
  create: async (data: TelegramSellerBody): Promise<TelegramSeller> =>
    (await apiClient.post(BASE, data)).data,
  update: async (id: string, data: TelegramSellerBody): Promise<TelegramSeller> =>
    (await apiClient.patch(`${BASE}${id}/`, data)).data,
  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE}${id}/`);
  },
};
